import classNames from 'classnames';

import BenefitsAccordionItem from './BenefitsAccordionItem';
import { BenefitsAccordionFragmentFragment } from '../../__generated__/graphql';
import { Heading2, Heading4 } from '../../components/Text';
import Section from '../../layout/Section';
import { ContentBlock } from '../types';

import style from './benefits-accordion.module.css';

const BenefitsAccordion: ContentBlock<BenefitsAccordionFragmentFragment> = ({ fragment }) => {
  const contentBlockProps = fragment.benefitsAccordion;

  if (!contentBlockProps) {
    return null;
  }

  return (
    <Section
      backgroundColor="white"
      id={contentBlockProps.sectionId}
      innerContainerClassName={style.benefitsAccordion}
    >
      <Heading2
        className={style.benefitsHeadingContainer}
        fontSizeOverride={36}
        fontWeight={300}
      >
        {contentBlockProps.title}
      </Heading2>

      <Heading4
        className={classNames(
          style.benefitsHeadingContainer,
          style.benefitsAccordionSubtitle,
        )}
        fontSizeOverride={20}
      >
        {contentBlockProps.subtitle}
      </Heading4>

      <div className={style.benefitsAccordionContainer}>
        {contentBlockProps.accordionItems?.map(benefit => {
          if (benefit?.accordionImage) {
            return (
              <BenefitsAccordionItem
                description={benefit.description}
                image={benefit.accordionImage}
                key={benefit.accordionImage.node.id}
                links={benefit.links}
              />
            );
          }
        })}
      </div>
    </Section>
  );
};

export default BenefitsAccordion;
